var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull center pt-1 pb-3" }, [
    _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-11  center" }, [
        _vm.PaypalOn
          ? _c("h4", { staticClass: "center" }, [
              _c("b", [
                _vm._v("Oppure puoi pagare con la tua carta "),
                _vm.sepaOn
                  ? _c("span", [_vm._v("o addebito diretto SEPA")])
                  : _vm._e()
              ])
            ])
          : _c("h4", { staticClass: "center" }, [
              _c("b", [
                _vm._v("Paga con la tua carta "),
                _vm.sepaOn
                  ? _c("span", [_vm._v("o con addebito bancario diretto SEPA")])
                  : _vm._e()
              ])
            ]),
        _vm._v(" "),
        _vm.sepaOn
          ? _c("img", {
              staticClass: "img-fluid widthFull mb-3 mt-3",
              attrs: { src: require("../../assets/images/card.png") }
            })
          : _c("img", {
              staticClass: "img-fluid widthFull mb-3 mt-3",
              attrs: { src: require("../../assets/images/cardonly.png") }
            })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8  center" }, [
        !_vm.show_card
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", id: "checkout-button" },
                on: { click: _vm.create_stripe_session }
              },
              [_vm._v(" Procedi ")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c3e6f9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3e6f9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/stripe.vue
// module id = null
// module chunks = 